<template>
    <AppWell class="mt-3">
        <form action="" @submit.prevent="search">
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-6 mt-1">
                    <label class="block text-sm font-medium leading-5 text-gray-700">{{ $t('messages.search') }}</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.search"
                            type="text"
                            :placeholder="`${$t('messages.search')}: ${$t('messages.title')}`"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                    </div>
                </div>

                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.subject', 1)" for="subject_id" />
                        <FormSelect
                            required
                            id="subject_id"
                            v-model="form.subject_id"
                            :options="props.options.subjects"
                            class="mt-1 w-full"
                        />
                    </div>
                </div>
                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.trimester')" for="trimester" />
                        <FormSelect
                            required
                            id="trimester"
                            v-model="form.trimester"
                            :options="props.options.trimesters"
                            class="mt-1 w-full"
                        />
                    </div>
                </div>
            </div>
            <div class="mt-3 flex justify-end">
                <AppButton desired-action element="button" type="submit"> {{ $t('messages.search') }}</AppButton>
            </div>
        </form>

        <div v-if="isFinished && activities.length === 0">
            <EmptyState :title="$t('messages.no_activities_found')" with-icon with-button />
        </div>
        <ul class="mt-3">
            <li v-for="activity in activities" :key="activity.id" class="flex gap-x-2 items-center">
                <span class="w-6 h-6 flex items-center justify-start">
                    <input
                        :id="`activity_${activity.id}`"
                        name="activity_id"
                        type="radio"
                        :value="activity.id"
                        v-model="selected"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        v-if="selected === activity.id || !activity.has_responses"
                    />
                    <span :title="$t('messages.station_can_not_use_activity_with_responses')" v-else>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="text-gray-400 w-4 h-4 icon icon-tabler icon-tabler-square-forbid-2"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <rect x="4" y="4" width="16" height="16" rx="2"></rect>
                            <line x1="9" y1="15" x2="15" y2="9"></line>
                        </svg>
                    </span>
                </span>
                <span>{{ activity.title }}</span>
            </li>
        </ul>
    </AppWell>
</template>

<script>
export default {
    name: 'StationActivitySelector',
    components: {},
};
</script>
<script setup>
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import axios from 'axios';
import { ref, onMounted } from 'vue';
import AppWell from '@/Shared/AppWell.vue';
import AppButton from '@/components/AppButton.vue';
import { useVModel } from '@vueuse/core';
import EmptyState from '@/components/EmptyState.vue';

let emit = defineEmits(['update:modelValue', 'subjectId']);

const props = defineProps({
    options: {
        type: Object,
        required: true,
    },
    defaults: {
        type: Object,
        required: true,
    },
    url: {
        type: String,
        required: true,
    },
    modelValue: {},
});

const form = ref({
    trimester: props.defaults.trimester,
    subject_id: null,
    search: null,
    type_in: props.defaults.types,
});

const isFinished = ref(false);

const selected = useVModel(props, 'modelValue', emit);

const activities = ref(props.options.inputActivities);

onMounted(() => {
    if (props.options.subjects.length === 1) {
        form.value.subject_id = props.options.subjects[0].id;
    }
});

const search = () => {
    isFinished.value = false;
    axios
        .get(props.url, {
            params: form.value,
        })
        .then((response) => {
            activities.value = response.data.items;
            isFinished.value = true;
            emit('subjectId', form.value.subject_id);
        });
};
</script>
